import { Component, inject } from '@angular/core';
import { ToastService } from '@black/ui';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'black-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.css'],
  standalone: false,
})
export class PlaygroundComponent {
  private toastService = inject(ToastService);


  addToast() {
    this.toastService.showToast('This is a success toast', 'info');
  }

  onImageUploaded(event: any) {
    console.log(event);
  }

  uploadUrl = environment.host + '/api/v1/upload/image-cropper';
}
